export const developers = [
  'Junior – 5 000 ',
  'Junior+ – 10 000 ',
  'Middle – 30 000 ',
  'Senior – 60 000 ',
  'Head – 100 000 ',
]

export const adminEmployees = [
  'Junior – 5 000 ',
  'Junior+ – 5 000 ',
  'Middle – 10 000 ',
  'Senior – 15 000 ',
  'Head – 20 000 ',
]
